import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useFontReady } from '../contexts/FontReadyContext';
import TidleLoadingSpinner from '../components/TidleLoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading, authReady, authIntent } = useAuth();
  const fontReady = useFontReady();

  // If auth is still loading or app font not ready, render the same spinner as RedirectPage
  if (loading || !authReady || !fontReady) {
    return <TidleLoadingSpinner />;
  }

  // If auth is ready but there is still no user, handle based on auth intent
  if (!currentUser) {
    if (authIntent === 'login') {
      // User explicitly logged out - send to /login (NOT /register)
      return <Navigate to="/login" />;
    } else {
      // Default guest intent - redirect to / (so RedirectPage/AuthContext can recover)
      return <Navigate to="/" />;
    }
  }

  // If the user is authenticated (or anonymous/guest), render the children
  return children;
};

export default ProtectedRoute;